<template>
    <el-dialog
       
        center
        class="w-project-examine-dialog"
        :title="config.title"
        :visible="centerDialogVisible"
        width="560px"      
        :before-close="cf">
            <el-form label-width="160px">
                <el-form-item label="素材名称">
                    <el-input
                        v-model="examineForm.midName"
                        show-word-limit
                        maxlength="20"
                        placeholder="请输入素材名称">
                    </el-input>
                </el-form-item>

                <el-form-item label="素材类型">
                    <el-select @change="styleChange" v-model="examineForm.style" placeholder="请选择素材类型">
                        <el-option :key="idx" v-for="(item, idx) in styles" :label="item.name" :value="item.type">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="综合评级">
                    <template v-if="grades.length">
                        <div class="p-level-item"
                            v-for="(level, idx) in grades"
                            :key="idx"
                            :class="{ 'p-level-item-active': level.level === examineForm.level }"
                            @click="levelChange(level.level)">
                            <img :src="level.samplePics">
                            <div class="p-level-content">
                                <h3>{{ level.level }}</h3>
                                <div class="p-level-desc">
                                    {{ level.levelStandard }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <span v-else class="p-tips">请选择素材类型</span>
                </el-form-item>

                <el-form-item label="标签">
                    <p class="p-tip">功能标签（请至少选择1个）</p>
                    <div class="p-tag-wrap">
                        <el-cascader
                            v-model="examineForm.funTags"
                            :show-all-levels="false"
                            ref="tag"
                            :options="tags"
                            :props="{ multiple: true }"
                            clearable>
                        </el-cascader>
                    </div>
                    <p class="p-tip">查询标签（请添加素材元素相关的标签，至少1个）</p>

                    <el-popover
                        placement="bottom"
                        title="提示"
                        width="200"
                        trigger="manual"
                        v-model="showTagAddPopover">
                        <div class="p-search-tag-add-popover">
                            <p>是否添加{{ newTag }}标签?</p>
                            <br>
                            <div style="text-align: center">
                                <el-button size="small" @click="cancelTagAdd">取消</el-button>
                                <el-button size="small" type="primary" @click="addTagSearchId">确定添加</el-button>
                            </div>
                        </div>
                        <div slot="reference">
                            <el-select
                                @focus="showTagAddPopover = false"
                                ref="searchTag"
                                no-data-text="无数据,请选择素材类型"
                                @change="currencyTagChange"
                                filterable
                                allow-create
                                multiple 
                                default-first-option
                                v-model="examineForm.currencyTag"
                                placeholder="请选择查询标签">
                                <el-option v-for="item in currencyTags" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </el-popover>
                </el-form-item>

                <el-form-item label="素材格式">
                    <el-select multiple v-model="examineForm.format" placeholder="请选择素材格式">
                        <el-option v-for="format in formats" :key="format" :label="format" :value="format">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否与IP相关">
                    <el-radio-group v-model="examineForm.isRelationIp" size="medium">
                        <el-radio-button :label="0" >无关</el-radio-button>
                        <el-radio-button :label="1">相关</el-radio-button>
                    </el-radio-group>

                    <el-select style="margin-top: 10px" v-model="examineForm.ip" placeholder="请选择素材相关的IP" v-if="+examineForm.isRelationIp === 1">
                        <el-option v-for="(item, idx) in ipList" :key="idx" :label="item.name" :value="item.ipId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="审核备注">
                    <el-input
                        v-model="examineForm.remarks"
                        show-word-limit
                        maxlength="100"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入审核备注">
                    </el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button :loading="examining" type="primary" @click="photoworkReviewcheck">确 定</el-button>
            </span>
    </el-dialog>
</template>
<script>
import { forEachTree} from '@/common/utils'
import camelcase from 'camelcase-keys-deep';
	export default {
        props:{
            config:Object
        },
		data() {
            return{
                centerDialogVisible:true,
                examineForm:{},
                tags:[],
                 // 风格列表
                styles: [],
                 // 评级列表
                grades: [],
                priceConfig: {},
                // 查询标签列表
                currencyTags: [],
                // 素材格式列表
                formats: [],
                ipList: [],
                showTagAddPopover: false,
                newTag: '',
                examining: false,
			}
		},
		methods: {
            cf(){
                this.close()
                return
            },
            levelChange(level) {
                this.$set(this.examineForm, 'level', level)
            },
            cancelTagAdd() {
            let idx = this.examineForm.currencyTag.indexOf(this.newTag)
                ~idx && this.examineForm.currencyTag.splice(idx, 1)

                this.showTagAddPopover = false
            },
            async addTagSearchId() {
                let tags = this.examineForm.currencyTag

                try {
                    await this.api.addTagSearchId({
                        name: this.newTag,
                        type: this.examineForm.style,
                        material: 1
                    })
                    await this.getTagSearchId()

                    const idx = tags.indexOf(this.newTag)
                    const tag = this.currencyTags.find(item => item.name === this.newTag)

                    if(~idx && tag) {
                        tags.splice(idx, 1, tag.id)
                        this.examineForm.currencyTag = tags

                        this.showTagAddPopover = false
                        this.$message.success('标签新增成功')
                    }else {
                        this.$message.error(`新增查询标签失败! 标签列表不存在${this.newTag}`)
                    }
                } catch (error) {
                    this.$message.error(`新增查询标签失败! ${error}`)
                }
        },
        // currencyTags 列表id
         async currencyTagChange(tags) {
            const newTag = tags.find(tagId => !this.currencyTags.find(item => item.id === tagId))
            this.newTag = newTag

            // 新增标签
            if(newTag) {
                this.$nextTick(() => {
                    this.$refs.searchTag.blur()
                    this.showTagAddPopover = true
                })
            }else {
                this.showTagAddPopover = false
            }
        },
            async getMidFormats() {
                this.formats = await this.api.getMidFormats()

                // 审核第一步，素材格式默认勾选
                if(this.config.fileName) {
                    let fileNameSlice = this.config.fileName.split('.')
                    let suffix = fileNameSlice.splice(-1)[0]

                    if(suffix) {
                        if(suffix === 'jpg') {
                            suffix = 'jpeg'
                        }
                        this.$set(this.examineForm, 'format', [suffix])
                    }
                }
            },
            async photoworkIpList() {
                let data = await this.api.photoworkIpList()
                this.ipList = data
            },
            async getGrades() {
                this.api.getProgressBusinesslist({ type:'4'}).then(da=>{
                    console.log(da);
                    da = JSON.parse(da.priceConfig || '{}');
                    let newConfig = {}

                    Object.keys(da).forEach(key => {
                        newConfig[key] = {}
                        Object.keys(da[key]).forEach(level => {
                            newConfig[key][level] = camelcase(da[key][level])
                        })
                    })

                    this.priceConfig = newConfig
                    this.getStyles();
                })
      
            },
            async getStyles() {
                let data = await this.api.getMidTypes()
                this.styles = data.filter(item => Object.keys(this.priceConfig).includes(item.type))
            },
            /*联动设置*/
            styleChange(val) {                
                this.getTagSearchId()
                if(this.priceConfig[val]) {
                    this.grades = Object.keys(this.priceConfig[val]).filter(key => key !== 'is_level').map(key => ({ level: key, ...this.priceConfig[val][key] }))
                }else {
                    this.grades = []
                    this.$message.warning('当前素材类型没有设置评级, 请到【内容-工具箱-业务流程管理】设置')
                }
            },
            async getTagSearchId() {
                this.$set(this.examineForm, 'currencyTag', [])
                let data = await this.api.getTagSearchId({
                    type: this.examineForm.style,
                    material: 1
                })
                this.currencyTags = JSON.stringify(data) === '{}' ? [] : data
            },
            
            async getTagFuncId() {
                let data = await this.api.getTagFuncId()
                this.tags = forEachTree(data, (item) => {
                    item.value = item.id
                    item.label = item.name
                })
            },
            
            close(n){
                this.$emit('close',n || '')
            },

		
            async photoworkReviewcheck() {
                let { style, currencyTag, format, remarks, level, fileUrl, fileName, fileSize, fileInfo, midName, isRelationIp, ip } = this.examineForm
               
               
                let tags = this.examineForm.funTags;

              
                if(!level) {
                    this.$message.error({ message: '请选择综合评级' })
                    return
                }
                if(!midName) {
                    this.$message.error('请输入素材名称')
                    return
                }
                if(midName.length > 20) {
                    this.$message.error('素材名称最大只能输入20个字')
                    return
                } 
                if(!style) {
                    this.$message.error('请选择素材类型')
                    return
                }
                if(!tags) {
                    this.$message.error('请选择功能标签')
                    return
                }
                if(!currencyTag) {
                    this.$message.error('请选择查询标签')
                    return
                } 
                if(!format) {
                    this.$message.error('请选择素材格式')
                    return
                }
                if(+isRelationIp === 1 && (ip === undefined || ip === '')) {
                    this.$message.error('请选择ip相关')
                    return
                }
                    try {
                        this.examining = true

                        await this.api.photoworkReviewcheck({
                            midType: style,
                            tagFuncId: tags.join(','),
                            tagSearchId: currencyTag.join(','),
                            midFormat: JSON.stringify(format),
                            remark: remarks,
                            type: this.config.type, // 固定写死
                            checkStatus: 1, // 固定写死
                            checkSteps: 1, // 固定写死
                            id:this.config.id,
                            level,
                            fileUrl,
                            fileName,
                            fileSize,
                            fileInfo: JSON.stringify(fileInfo),
                            midName,
                            isRelationIp,
                            ip,
                            formats: JSON.stringify({
                                '稿件归档': undefined,
                                '素材名称': midName,
                                '素材类型': this.currentStyleName,
                                '综合评级': level,
                                '功能标签': this.currentTagNames,
                                '查询标签': this.currencyTagNames,
                                '素材格式': format,
                                '是否与IP相关': this.currentIpName,
                                '备注': remarks
                            })
                        })
                        this.showExamineDialog = false
                        this.$message.success('审核通过成功')
                        this.$emit('close','sx')
                    } finally {
                        this.examining = false
                    }
               
            },
       
		},

		mounted() {
           this.$set(this.examineForm,'midName',this.config.fileName)
           this.getGrades();
           this.getTagFuncId();
           this.getMidFormats();
           this.photoworkIpList();

		}
	}
</script>

<style>


</style>

<style scoped>

</style>
